import React from "react";
import { Box } from "@material-ui/core";
import UserDetail from "../UserDetail/UserDetail";
import appBarUserDetailsStyles from "./AppBarUserDetailsStyles";

const AppBarUserDetails: React.FC<{ logout: () => Promise<void> }> = (props) => {
	const { logout } = props;
	const classes = appBarUserDetailsStyles();
	const useWhiteLine = false; // I don't understand this white line, it looks off

	return (
		<Box className={useWhiteLine ? classes.leftBorderWhite : null}>
			<UserDetail logout={logout} />
		</Box>
	);
};
export default AppBarUserDetails;
